import MuiGrid from './MuiGrid';
import MuiTextField from "./MuiTextField"
import MuiButton from "./MuiButton"
import MuiCard from "./MuiCard"
import MuiPaper from "./MuiPaper"
import MuiTypography from "./MuiTypography"
import MuiOutlinedInput from './MuiOutlinedInput'
import MuiSwitch from './MuiSwitch'

export default {
	MuiGrid,
	MuiButton,
	MuiCard,
	MuiPaper,
	MuiTypography,
	MuiOutlinedInput,
	MuiSwitch
};
